export default "__VITE_ASSET__hNGJajfJ__"